import {
  IEmployeeWorkgroup,
  IEmployeeWorkgroupData
} from './employee-workgroup.types';

export class EmployeeWorkgroup implements IEmployeeWorkgroup {
  readonly id?: number;
  readonly name: string;
  readonly description: string = '';

  constructor(data: IEmployeeWorkgroupData) {
    this.name = data.name;

    if (data.id) {
      this.id = data.id;
    }
    if (data.description) {
      this.description = data.description;
    }
  }

  validate(): boolean {
    throw new Error('Method not implemented.');
  }

  toString(): string {
    return `${this.name}`.trim();
  }
}
